import localforage from 'localforage'
localforage.config({
  name:"mpChat" // 数据库名称为mpChat
})


export default {
  fetch (STORAGE_KEY) {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '[]')
  },
  save (STORAGE_KEY, items) {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  },
  remove (STORAGE_KEY) {
    window.sessionStorage.removeItem(STORAGE_KEY)
  },
  clear () {
    window.sessionStorage.clear()
  },
  fetchLocalforage (STORAGE_KEY,callback) {
    localforage.getItem(STORAGE_KEY).then(value => {
      callback(value)
    })
  },
  saveLocalforage (STORAGE_KEY, items) {
    localforage.setItem(STORAGE_KEY, items)
  },
  removeLocalforage (STORAGE_KEY) {
    localforage.removeItem(STORAGE_KEY)
  },
  clearLocalforage () {
    localforage.clear()
  },
}
